import 'select2';

$('.js-select-direction').select2({
  minimumResultsForSearch: -1,
  placeholder: "Выберите направление*",
});

$("#landing-form").validate({
  rules: {
    systemtype: {
      required: true
    },
  },
  messages: {
    systemtype: {
      required: "Поле обязательно для заполнения",
    },
  },
  errorPlacement: function(label, element) {
    if (element.hasClass('web-select2')) {
      label.insertAfter(element.next('.select2-container')).addClass('text-danger');
      select2label = label
    } else {
      label.addClass('text-danger');
      label.insertAfter(element);
    }
  },
  highlight: function(element) {
    $(element).parent().addClass('is-invalid')
    $(element).addClass('form-control-danger')
  },
  success: function(label, element) {
    $(element).parent().removeClass('is-invalid')
    $(element).removeClass('form-control-danger')
    label.remove();
  },
});
